import { api } from '../../../../app/baseQuery';
import { HTTPResponse } from '../../../../common/types/commonTypes';
import { SALESMANCOMMISSIONREPORT } from '../../Api/constants';
import { ITodayPurchasePaymentReport, ITodaySalesReport } from '../types/totalCollectionTypes';

export const totalCollectionPayments = api.injectEndpoints({
  endpoints: (build) => ({
    todaySalesReport: build.query<HTTPResponse<ITodaySalesReport>, void>({
      query: (body) => ({
        url: `/report/today/sales-report`,
      }),
      providesTags: [{ type: 'SaleaManCommissionReport', id: SALESMANCOMMISSIONREPORT }],
    }),
    todayPurchasePayments: build.query<HTTPResponse<ITodayPurchasePaymentReport>, void>({
      query: (body) => ({
        url: `/report/today/payment-purchase`,
      }),
      providesTags: [{ type: 'SaleaManCommissionReport', id: SALESMANCOMMISSIONREPORT }],
    }),
  }),
});

export const { useTodaySalesReportQuery, useTodayPurchasePaymentsQuery } = totalCollectionPayments;
